module.exports = __webpack_public_path__ + "img/ship.6b737186.png";